export class StartStreamingSessionResponse {
  authorizeUrl?: string;
}
